import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import * as PR from "../../prime-modules/index";
import { affiliateusers, deleteUserEsim, esimsICCID, esimsV2, getAffiliateUsersList, getUserDetails, restoreUserEsim, updateCustomerName, updateUser } from "../../services/api";
import 'react-phone-input-2/lib/high-res.css'
import AdminFooter from "../layout/admin-footer";
import AdminHeader from "../layout/admin-header";
import { useSelector, useDispatch } from 'react-redux';
import "./CustomerDetails.scss";
import { useNavigate, useParams } from "react-router-dom";
import { checkDataSize, formatDateTime } from "../../utils/reuse";
import EditableNameCell from "../users/EditableNameCell";
import EditableEmailCell from "../users/EditableEmailCell";
import NameModal from "../users/NameModal";
import PriceDisplay from "../../components/PriceDisplay";
import * as utils from '../../utils';
import { PERMISSIONS, hasPermission } from "../../utils/permissions";


const CustomerDetails = (route) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const adminData = useSelector(state => state.adminAuth.adminSessionData);
    const headers = useMemo(() => {
        return { sessionid: adminData.sessionId };
    }, [adminData.sessionId]);

    const [sortOrder] = useState(-1);
    const navigate = useNavigate();

    const toast = useRef();
    const menuRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [activeEsim, setActiveEsim] = useState(null);

    const [affiliateName, setAffiliateName] = useState('');
    const [userDisabled, setUserDisabled] = useState(false)

    const [expandedRows, setExpandedRows] = useState([]);

    const [esimDetailsList, setEsimDetailsList] = useState([]);
    const [affiliate, setAffiliate] = useState([])
    const [userData, setUserData] = useState({})
    const [editAffiliate, setEditAffiliate] = useState(false)
    const [affName, setAffName] = useState("")
    const [editDialog, setEditDialog] = useState(false)
    const [afId, setAfId] = useState("")
    const [affiliateLoader, setAffiliateLoader] = useState(false)
    const [nameModal, setNameModal] = useState(false)
    const [userIds, setUserIds] = useState({ userId: "", to: "", rowData: {}, })

    const [deleteDialog, setDeleteDialog] = useState(false)
    const [esimActionDialog, setEsimActionDialog] = useState(false)
    const [esimActionLoading, setEsimActionLoading] = useState(false)

    const [checked, setChecked] = useState(false);
    const [eSimSortField, setESimSortField] = useState('latestPurchaseDate');
    const [eSimSortOrder, setESimSortOrder] = useState(-1);

    const [isMobile, setIsMobile] = useState(false);
    const home = { icon: 'pi pi-home', url: '/' }
    const copyToClipboard = (text, message = 'Customer ID') => {
        navigator.clipboard.writeText(text).then(() => {
            toast.current?.show({ severity: 'success', summary: 'Success', detail: `${message} has been copied to clipboard.` });
        }).catch(err => {
            toast.current?.show({ severity: 'warn', summary: 'Warning', detail: 'Failed to copy.' });
        });
    };
    const items = useMemo(() => {
        let items = [
            {
                label: 'Customers',
                command: () => navigate('/users')
            },
            {
                label: id,
                disabled: true,
            },
            {
                template: (
                    <PR.Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm ml-20 icon-button"
                        onClick={() => copyToClipboard(id)}
                        tooltip="Copy Customer ID"
                        tooltipOptions={{ position: 'top' }}
                    />
                ),
            }
        ]
        return items;
    }, [navigate, id]);
    // Default row expansion on mobile devices 
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 960);
        };

        handleResize(); // Check initially
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isMobile && esimDetailsList.length > 0) {
            const allIccids = esimDetailsList.map(item => item.iccid);
            setExpandedRows(allIccids);
        }
    }, [isMobile, esimDetailsList, checked]);

    const getUser = useCallback(async () => {
        setLoading(true);

        getUserDetails(id, headers, dispatch, response => {
            if (response.result === 'SUCCESS') {
                setUserData(response.data)
                setAffiliateName(response?.data?.affiliateName)
                setUserDisabled(response?.data?.isDisabled)
            } else {
                const error = response.error;
                toast.current.show({ severity: error.severity, summary: 'Error', detail: (error.errorMsg) ? error.errorMsg : error.summary })
            }
            setLoading(false);
        })

    }, [headers, id, dispatch])

    const getAllAffiliateUsers = useCallback(async () => {
        if (!hasPermission(adminData?.permission, PERMISSIONS.VIEW_AFFILIATES)) return;
        const sortOrderVal = (sortOrder === 1) ? "asc" : "desc";
        const obj = {
            offset: 0,
            limit: 1000,
            sortField: "",
            sortOrder: sortOrderVal,
            name: "",
            affiliateName: "",
            email: "",
            phone: "",
            isActive: "",
            createdDateFrom: "",
            createdDateTo: "",
        };
        getAffiliateUsersList(obj, headers, dispatch, response => {
            if (response.result === 'SUCCESS') {
                const list = response.data;
                setAffiliate(list)
            }
        })
    }, [headers, dispatch, sortOrder, adminData?.permission])


    const getEsimsICCID = useCallback(
        (iccid) => {
            setLoading(true);
            let getResponse = (response) => {
                setLoading(false);
                if (response.result === "SUCCESS") {
                    setEsimDetailsList((prevState) => ([...prevState, response?.data]))
                } else {
                    setLoading(false);
                    const error = response.error;
                    toast.current?.show({
                        severity: error.severity,
                        summary: "Error",
                        detail: error.errorMsg ? error.errorMsg : error.summary,
                    });
                }
            };
            esimsICCID(iccid, headers, dispatch, getResponse);
        },
        [headers, dispatch]
    );

    const onSort = (e) => {
        setESimSortField(e.sortField);
        setESimSortOrder(e.sortOrder);
    };
    const getEsims = useCallback(() => {
        setLoading(true);
        setEsimDetailsList([]);
        let getResponse = (response) => {
            setLoading(false);
            if (response?.result === "SUCCESS") {
                const esimsData = Array.isArray(response.data) ? response.data : [];
                if (esimsData.length > 0) {
                    for (const iccidItem of esimsData) {
                        getEsimsICCID(iccidItem.iccid);
                    }
                } else {
                    setLoading(false);
                    toast.current?.show({
                        severity: "warn",
                        summary: "Warning",
                        detail: "No records found",
                    });
                }
            } else {
                setLoading(false);
                const error = response?.error || {};
                toast.current?.show({
                    severity: error.severity,
                    summary: "Error",
                    detail: error.errorMsg ? error.errorMsg : error.summary,
                });
            }
        };
        esimsV2(id, headers, dispatch, getResponse);
    }, [id, headers, dispatch, getEsimsICCID]);

    useEffect(() => {
        getUser()
    }, [getUser])

    useEffect(() => {
        if (hasPermission(adminData?.permission, PERMISSIONS.VIEW_AFFILIATES)) {
            getAllAffiliateUsers();
        }
    }, [getAllAffiliateUsers, adminData?.permission])

    useEffect(() => {
        getEsims()
    }, [getEsims])

    const expiredBundles = (esimDetailsList) => {
        return esimDetailsList.filter(item => {
            let temp = item.activeBundlesData.filter((bundle) => bundle.state === 'expired')
            return temp.length > 0
        })
    }

    const processedEsimsList = useMemo(() => {
        return esimDetailsList.map(esim => {
            const bds = [...(esim.activeBundlesData || [])].sort((a, b) => {
                const timeA = a.createdTs ? new Date(a.createdTs).getTime() : 0;
                const timeB = b.createdTs ? new Date(b.createdTs).getTime() : 0;
                return (isNaN(timeB) ? 0 : timeB) - (isNaN(timeA) ? 0 : timeA);
            });
            let latestDate = 0;
            if (bds.length > 0) {
                latestDate = bds[0].createdTs ? new Date(bds[0].createdTs).getTime() : 0;
            }
            return { ...esim, activeBundlesData: bds, latestPurchaseDate: latestDate };
        });
    }, [esimDetailsList]);

    const filteredBundles = useMemo(() => {
        const bundles = checked
            ? expiredBundles(processedEsimsList)
            : processedEsimsList;

        if (eSimSortField) {
            return [...bundles].sort((a, b) => {
                const valA = a[eSimSortField] || 0;
                const valB = b[eSimSortField] || 0;
                let result = (valA < valB) ? -1 : (valA > valB) ? 1 : 0;
                return eSimSortOrder * result;
            });
        }
        return bundles;
    }, [processedEsimsList, checked, eSimSortField, eSimSortOrder]);

    const isEsimDeleted = useCallback((esim) => Boolean(esim?.isDeleted ?? esim?.deleted), []);

    const handleEsimAction = useCallback(() => {
        if (!activeEsim?.iccid) return;

        const restoring = isEsimDeleted(activeEsim);
        const request = restoring ? restoreUserEsim : deleteUserEsim;
        setEsimActionLoading(true);

        request(id, activeEsim.iccid, headers, dispatch, (response) => {
            setEsimActionLoading(false);
            if (response.result === "SUCCESS") {
                toast.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: restoring ? "eSIM restored successfully." : "eSIM deleted successfully.",
                });
                setEsimActionDialog(false);
                setActiveEsim(null);
                getEsims();
                return;
            }

            const error = response.error || {};
            toast.current?.show({
                severity: error.severity || "error",
                summary: "Error",
                detail: error.errorMsg || error.summary || "Unable to update the eSIM. Please try again.",
            });
        });
    }, [activeEsim, dispatch, getEsims, headers, id, isEsimDeleted]);

    const actionMenuItems = useMemo(() => [
        {
            label: "View order details",
            command: () => {
                const latestBundle = activeEsim?.activeBundlesData?.[0];
                if (latestBundle?.orderId) {
                    window.open(`/orders/details/${latestBundle.orderId}`, "_blank");
                }
            },
            disabled: !activeEsim?.activeBundlesData?.[0]?.orderId
        },
        {
            label: "View eSIM details",
            command: () => {
                if (activeEsim?.iccid) {
                    window.open(`/esim-details/${activeEsim.iccid}?orderId=${activeEsim.activeBundlesData?.[0]?.orderId}`, "_blank");
                }
            }
        },
        {
            label: isEsimDeleted(activeEsim) ? "Undelete eSIM" : "Delete eSIM",
            command: () => setEsimActionDialog(true),
            disabled: !activeEsim?.iccid
        }
    ], [activeEsim, isEsimDeleted]);

    const handleUserActivate = (newUserDisabled) => {
        setLoading(true);

        let obj = {
            userId: id,
            isDisabled: newUserDisabled
        };

        updateUser(obj, headers, dispatch, (response) => {
            if (response.result === 'SUCCESS') {
                setUserDisabled(newUserDisabled); // Update local state
                if (!newUserDisabled) {
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: "Customer has been activated successfully."
                    });
                } else {
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: "Customer has been suspended successfully."
                    });
                }
                getUser();
            } else {
                const error = response.error;
                toast.current?.show({
                    severity: error.severity,
                    summary: 'Error',
                    detail: error.errorMsg || error.summary
                });
            }
            setLoading(false);
        });
    };

    const handleRowClick = (e) => {
        const isToggler = e?.originalEvent?.target?.closest('.p-row-toggler');
        if (isToggler) return;

        const rowData = e.data;
        if ((rowData?.activeBundlesData || []).length <= 1) return;

        setExpandedRows((prev) => {
            const expandedSet = new Set(prev);
            if (expandedSet.has(rowData.iccid)) {
                expandedSet.delete(rowData.iccid);
            } else {
                expandedSet.add(rowData.iccid);
            }
            return Array.from(expandedSet);
        });
    };

    // Handle built-in row toggle action
    const onRowToggle = (e) => {
        const rowDataList = e.data; // PrimeReact passes an array of expanded rows

        // Make sure we extract the ICCID list safely
        const newExpandedRows = rowDataList?.map(row => row.iccid) ?? [];

        setExpandedRows(newExpandedRows);
    };

    const handleAffiliateChange = (value) => {
        if (!value) {
            setAffName("");
            setAfId("");
            return;
        }
        const affiliateList = Array.isArray(affiliate) ? affiliate : [];
        const selectedAffiliateObj = affiliateList.find(aff => aff.id === value);
        setAffName(selectedAffiliateObj ? selectedAffiliateObj.name : "");
        setAfId(value);
        setEditDialog(true);
    };

    const rowExpansionTemplate = (rowData) => {
        const remainingBundles = (rowData?.activeBundlesData || []).slice(1);
        if (remainingBundles.length === 0) {
            return null;
        }
        return (
            <div className="card">
                <PR.DataTable value={remainingBundles} dataKey="id" className="affiliate-expansion-table" emptyMessage={<span className="text-gray-500">No results found</span>}>
                    <PR.Column style={{ width: "1%" }} className="toggler-expander" />
                    <PR.Column className="batch-column" style={{ width: "12%" }} />
                    <PR.Column
                        body={(bundle) => (
                            <>
                                <div className="aff-data">
                                    {bundle?.description || "-"}
                                </div>
                            </>
                        )}
                        style={{ width: "10%" }}
                    />
                    <PR.Column
                        body={(bundle) => (
                            <span className="email-column">{bundle?.isUnlimited
                                ? "Unlimited"
                                : `${`${checkDataSize(
                                    bundle?.remainingData
                                )}`} / ${checkDataSize(
                                    bundle?.totalData
                                )} left`}</span>
                        )}
                        style={{ width: "10%" }}
                    />
                    <PR.Column body={userStatus} header="Status" style={{ width: "8%" }} />
                    <PR.Column
                        body={(bundle) => (
                            <div className="price">
                                <PriceDisplay rowData={bundle} />
                            </div>
                        )}
                        style={{ width: "8%" }}
                    />

                    <PR.Column
                        body={(bundle) => {
                            let splitOrderId = bundle.orderId.split('-')
                            let shortOrderId = splitOrderId[splitOrderId.length - 1]
                            return (
                                <span className="email-column">{shortOrderId || "-"}</span>
                            )
                        }}
                        style={{ width: "8%" }}
                    />
                    <PR.Column
                        body={(bundle) => (<>
                            <span className="email-column">{formatDateTime(bundle?.createdTs)}</span>
                        </>
                        )}
                        style={{ width: "10%" }}
                    />
                    <PR.Column
                        body={(bundle) => (<>
                            <span className="email-column">{formatDateTime(bundle?.bundleEndTime)}</span>
                        </>
                        )}
                        style={{ width: "9%" }}
                    />
                    <PR.Column header="Actions" body={actionsChild} style={{ width: "5%" }} className="actions-column text-center1" />
                </PR.DataTable>
            </div>
        );
    };

    const userStatus = (bundle) => {
        return (
            <span className={`status ${bundle?.state}`}>{bundle?.state}</span>
        )
    };

    const actionsChild = (bundle) => {
        return bundle?.orderId ? <PR.Button icon="pi pi-chevron-right" tooltip="View order details" tooltipOptions={{ position: 'top' }} onClick={() => window.open(`/orders/details/${bundle?.orderId}`, "_blank")} className="p-button-rounded p-button-text p-button-plain p-button-icon-only" /> : <p>-</p>;
    };

    const actions = (esim) => {
        return (
            <div className="flex">
                <PR.Button
                    icon="pi pi-ellipsis-v"
                    className="p-button-rounded p-button-text p-button-plain p-button-icon-only action-ellipsis"
                    onClick={(e) => {
                        setActiveEsim(esim);
                        menuRef.current.toggle(e);
                    }}
                />
            </div>
        );
    };

    const activateSuspend = (rowData) => {
        return (
            <div onClick={(e) => e.stopPropagation()}>
                <PR.InputSwitch
                    disabled={loading || !hasPermission(adminData?.permission, PERMISSIONS.MANAGE_USERS)}
                    checked={!userDisabled} // UI shows active when userDisabled is false
                    onChange={(e) => handleUserActivate(!e.value)} // Pass inverted value for updating
                />
            </div>
        )
    };
    const handleExpiredSwitchButton = (value) => {
        setChecked(value)
        setExpandedRows([])
    }

    const renderAffiliateSection = (rowData) => {
        const affiliateList = Array.isArray(affiliate) ? affiliate : [];
        const currentAffiliateObj = affiliateList.find(aff => aff.name === affiliateName);
        const selectedValue = afId || currentAffiliateObj?.id || null;
        const canManageUsers = hasPermission(adminData?.permission, PERMISSIONS.MANAGE_USERS);

        return (editAffiliate && canManageUsers) ? (
            <PR.Dropdown
                showClear
                value={selectedValue}
                filter
                resetFilterOnHide
                onChange={(e) => {
                    if (e.value === null || e.value === undefined) {
                        setEditAffiliate(false);
                        setAfId("");
                        setAffName("");
                    } else {
                        handleAffiliateChange(e.value);
                    }
                }}
                onShow={() => {
                    if (!affiliate || affiliate.length === 0) getAllAffiliateUsers();
                }}
                placeholder="Select Affiliate"
                options={affiliateList
                    .filter(aff => aff.isActive)
                    .map(aff => ({ label: aff.name, value: aff.id }))
                    .sort((a, b) => a.label.localeCompare(b.label))}
            />
        ) : (
            <>
                {affiliateName ? (
                    <div className="affiliate-edit">
                        <span className="affiliate-name">{affiliateName}</span>
                        {canManageUsers && (
                            <div className="flex">
                                <PR.Button onClick={() => {
                                    if (!affiliate || affiliate.length === 0) getAllAffiliateUsers();
                                    setEditAffiliate(true);
                                }} >
                                    <i className="pi pi-pencil"></i>
                                </PR.Button>
                                <PR.Button className="close" onClick={() => {
                                    setAffName(affiliateName);
                                    setDeleteDialog(true);
                                }}>
                                    <i className="pi pi-times"></i>
                                </PR.Button>
                            </div>
                        )}
                    </div>
                ) : (
                    canManageUsers ? (
                        <PR.Button className="assign-button" onClick={() => {
                            if (!affiliate || affiliate.length === 0) getAllAffiliateUsers();
                            setEditAffiliate(true);
                        }}>
                            + Assign Affiliate
                        </PR.Button>
                    ) : (
                        <span>-</span>
                    )
                )}
            </>
        );
    };

    const handleDeleteDialogClose = () => {
        setDeleteDialog(false);
        setAffName("");
    };

    const handleSave = (val) => {
        setLoading(true);
        const obj = {
            userId: id,
            firstName: val,
        };
        updateCustomerName(obj, headers, dispatch, response => {
            if (response.result === 'SUCCESS') {
                getUser()
                toast.current?.show({ severity: 'success', summary: 'Success', detail: "Customer name updated successfully." })
            } else {
                const error = response.error;
                toast.current?.show({ severity: error.severity, summary: 'Error', detail: (error.errorMsg) ? error.errorMsg : error.summary })
            }
            setLoading(false);
        })
    };

    const handleDialogClose = () => {
        setAffName("");
        setAfId("");
        setEditAffiliate(false);
    };

    const handleEditDialogClose = () => {
        setEditDialog(false);
        setAffName("");
        setAfId("");
        setEditAffiliate(false);
    };

    const handleUpdateAffiliate = () => {
        setAffiliateLoader(true);
        const obj = {
            ids: [id],
            affiliateUserId: afId
        };
        const response = (response) => {
            setAffiliateLoader(false);
            if (response.result === "SUCCESS") {
                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: affiliateName ? "Affiliate Updated Successfully" : "Affiliate Associated Successfully",
                });
                getUser();
                handleDialogClose();
                handleEditDialogClose();
            } else if (response.result === "FAILED" && response.error) {
                const error = response.error;
                toast.current?.show({
                    severity: error.severity,
                    summary: "Error",
                    detail: error.errorMsg ? error.errorMsg : error.summary,
                });
            }
            setEditAffiliate(false);
        };
        affiliateusers(obj, headers, dispatch, response);
    };

    const deleteAffiliate = () => {
        setLoading(true);
        const obj = {
            ids: [id]
        };
        const response = (response) => {
            setLoading(false);
            if (response.result === "SUCCESS") {
                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Affiliate Removed Successfully",
                });
                setAffiliateName("");
                getUser();
                handleDeleteDialogClose();
            } else if (response.result === "FAILED" && response.error) {
                const error = response.error;
                toast.current?.show({
                    severity: error.severity,
                    summary: "Error",
                    detail: error.errorMsg ? error.errorMsg : error.summary,
                });
            }
        };
        affiliateusers(obj, headers, dispatch, response);
    };

    const displayedBundles = checked
        ? filteredBundles.filter(bundle => bundle.activeBundlesData?.[0]?.state === "expired")
        : filteredBundles.filter(bundle => bundle.activeBundlesData?.[0]?.state !== "expired");

    return (
        <>
            <div className="main">
                <div className="layout-sidebar">
                    <AdminHeader />
                </div>
                <div className="layout-content-wrapper">
                    <section className="admin-affiliateslist-section customer-details-section">
                        <div className="grid grid-nogutter">
                            <div className="col-12">
                                <div className="heading-sec">
                                    <div className="right flex align-items-center ">
                                        <h1>Customer Details</h1>
                                         <div className="breadcrumb-section">
                                            <PR.BreadCrumb model={items} home={home} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="users-data-table mt-0 mb-5">
                            <div className="card">
                                <PR.DataTable
                                    dataKey="id"
                                    cellMemo={false}
                                    loading={loading}
                                    value={userData && Object.keys(userData).length > 0 ? [{ ...userData, id: id }] : []}
                                    className="customer-details-table vouchers-table affiliate-management-table"
                                    emptyMessage={<span className="text-gray-500">No results found</span>}
                                >

                                    <PR.Column
                                        header="Name"
                                        style={{ width: "18%" }}
                                        body={() => (
                                            <EditableNameCell
                                                value={userData?.name}
                                                onSave={(val) => handleSave(val)}
                                                setNameModal={setNameModal}
                                                setUserIds={setUserIds}
                                                rowData={{ ...userData, userId: id }}
                                                canEdit={hasPermission(adminData?.permission, PERMISSIONS.MANAGE_USERS)}
                                            />
                                        )}
                                    />
                                    <PR.Column
                                        header="Email ID"
                                        style={{ width: "20%" }}
                                        body={() => (
                                            <EditableEmailCell
                                                value={userData?.email}
                                                setNameModal={setNameModal}
                                                setUserIds={setUserIds}
                                                rowData={{ ...userData, userId: id }}
                                                toast={toast}
                                                onSuccess={getUser}
                                                canEdit={hasPermission(adminData?.permission, PERMISSIONS.MANAGE_USERS)}
                                            />
                                        )}
                                    />
                                    <PR.Column
                                        header="Phone number"
                                        body={() => (
                                            <span className="email-column">
                                                {userData?.phone?.localPhoneNumber
                                                    ? userData.phone.callingCode + userData.phone.localPhoneNumber
                                                    : "-"}
                                            </span>
                                        )}
                                    />
                                    <PR.Column
                                        header="Life Time Value (LTV)"
                                        className="discount-column align-center"
                                        headerClassName="discount-header"
                                        body={() => (
                                            <span className="email-column">
                                                {userData?.ltv && Object.keys(userData?.ltv).length > 0
                                                    ? Object.entries(userData?.ltv)
                                                        .map(([key, value]) => `${key}: ${value}`)
                                                        .join(', ')
                                                    : 'N/A'}
                                            </span>

                                        )}
                                    />
                                    <PR.Column
                                        header="Affiliate Name"
                                        className="discount-column align-center"
                                        headerClassName="discount-header"
                                        body={renderAffiliateSection}
                                    />
                                    <PR.Column body={activateSuspend} header={`User Status`} style={{ width: "12%" }} className="discount-column align-center"
                                        headerClassName="discount-header" />
                                </PR.DataTable>
                            </div>
                        </div>
                        <div className="flex align-items-center justify-content-between m-flex">
                            <h2>Associated eSIMs & Orders</h2>
                            <div className="switch-toggle">
                                <PR.InputSwitch checked={checked} onChange={(e) => handleExpiredSwitchButton(e.value)} />
                                <span>Expired bundle</span>
                            </div>
                        </div>
                        <div className="users-data-table card">
                            <div className="card">
                                <PR.DataTable
                                    loading={loading}
                                    value={displayedBundles}
                                    
                                    sortField={eSimSortField}
                                    sortOrder={eSimSortOrder}
                                    onSort={onSort}
                                    expandedRows={displayedBundles.filter(esim => expandedRows.includes(esim.iccid))}
                                    onRowClick={handleRowClick}
                                    onRowToggle={onRowToggle}
                                    rowExpansionTemplate={rowExpansionTemplate}
                                    className="customer-details-table vouchers-table affiliate-management-table associated-table"
                                    emptyMessage={<span className="text-gray-500">No results found</span>}
                                    rowClassName={(rowData) => [
                                        rowData?.isDeleted ? 'deleted-row' : '',
                                        (rowData?.activeBundlesData || []).length <= 1 ? 'no-expansion-row' : '',
                                    ].filter(Boolean).join(' ')}
                                >
                                    <PR.Column expander style={{ width: "1%" }} className="expander-column" />
                                    <PR.Column
                                        header="ICCID & MSISDN"
                                        className="batch-column"
                                        style={{ width: "12%" }}
                                        body={(rowData) => {
                                            return (
                                                <div className="flex flex-column gap-1">
                                                    <span className="email-column">{rowData.iccid}</span>
                                                    {rowData.msisdn && <span className="email-column">
                                                        {utils.formatUKPhoneNumber(rowData.msisdn)}</span>}
                                                </div>
                                            );
                                        }}
                                    />
                                    <PR.Column
                                        header="Bundle Name"
                                        body={(rowData) => {
                                            const latestBundle = rowData.activeBundlesData?.[0];
                                            return (
                                                    <div className="flex align-items-center gap-3">
                                                        <span className="email-column">{latestBundle?.description || "-"}</span>
                                                    </div>
                                            );
                                        }}
                                        style={{ width: "10%" }}
                                    />
                                    <PR.Column
                                        header="Usage"
                                        body={(rowData) => {
                                            const latestBundle = rowData.activeBundlesData?.[0];
                                            if (!latestBundle) return "-";
                                            return (
                                                <span className="email-column">{latestBundle?.isUnlimited
                                                    ? "Unlimited"
                                                    : `${`${checkDataSize(
                                                        latestBundle?.remainingData
                                                    )}`} / ${checkDataSize(
                                                        latestBundle?.totalData
                                                    )} left`}</span>
                                            );
                                        }}
                                        style={{ width: "10%" }}
                                    />
                                    <PR.Column
                                        header="Status"
                                        body={(rowData) => {
                                            const latestBundle = rowData.activeBundlesData?.[0];
                                            return isEsimDeleted(rowData)
                                                ? <span className={`status expired`}>Deleted</span>
                                                : latestBundle ? userStatus(latestBundle) : "-";
                                        }}
                                        style={{ width: "8%" }}
                                        className="discount-column"
                                    />
                                    <PR.Column
                                        header="Price"
                                        body={(rowData) => {
                                            const latestBundle = rowData.activeBundlesData?.[0];
                                            if (!latestBundle) return "-";
                                            return (
                                                <div className="price">
                                                    <PriceDisplay rowData={latestBundle} />
                                                </div>
                                            );
                                        }}
                                        style={{ width: "8%" }}
                                        className="discount-column"
                                    />

                                    <PR.Column
                                        header="Order ID"
                                        body={(rowData) => {
                                            const latestBundle = rowData.activeBundlesData?.[0];
                                            if (!latestBundle?.orderId) return "-";
                                            let splitOrderId = latestBundle.orderId.split('-')
                                            let shortOrderId = splitOrderId[splitOrderId.length - 1]
                                            return (
                                                <span className="email-column">{shortOrderId || "-"}</span>
                                            )
                                        }}
                                        style={{ width: "8%" }}
                                    />
                                    <PR.Column
                                        header="Purchase date"
                                        style={{ width: "10%" }}
                                        sortable
                                        field="latestPurchaseDate"
                                        headerClassName="cursor-pointer purchase-date-header"
                                        body={(rowData) => {
                                            const latestBundle = rowData.activeBundlesData?.[0];
                                            return (
                                                <span className="email-column">{latestBundle ? formatDateTime(latestBundle?.createdTs) : "-"}</span>
                                            );
                                        }}
                                    />
                                    <PR.Column
                                        header="Expiry date"
                                        body={(rowData) => {
                                            const latestBundle = rowData.activeBundlesData?.[0];
                                            return (
                                                <span className="email-column">{latestBundle ? formatDateTime(latestBundle?.bundleEndTime) : "-"}</span>
                                            );
                                        }}
                                        style={{ width: "9%" }}
                                    />
                                    <PR.Column body={actions} header="Actions" style={{ width: "5%" }} className="actions-column text-center1" />
                                </PR.DataTable>
                            </div>
                        </div>

                        <PR.Dialog
                            visible={editDialog}
                            dismissableMask={true}
                            draggable={false}
                            resizable={false}
                            header={affiliateName ? "Change Affiliate" : "Confirm Affiliate"}
                            onHide={handleEditDialogClose}
                            className="affiliate-dialog affiliate-assign"
                            maskClassName="affiliate-dialog-mask"
                        >
                            <div>
                                <div style={{ marginTop: '1rem' }}>
                                    <p>Are you sure you want to associate this <strong>{userData?.name}</strong> with <strong>{affName}</strong> ?</p>
                                </div>
                                {affiliateName && (
                                    <div style={{ marginTop: '1rem' }}>
                                        <p>Changing the affiliate means that future order credits will no longer be assigned to any affiliate and may also impact the discount value for <strong> {userData?.name} </strong>.</p>
                                    </div>
                                )}
                                <div className="dialog-footer buttons-sections flex gap-3 align-items-center justify-content-end">
                                    <PR.Button disabled={affiliateLoader} label="Confirm" onClick={handleUpdateAffiliate} className="confirm-button min-width" />
                                </div>
                            </div>
                        </PR.Dialog>
                        <PR.Dialog
                            visible={deleteDialog}
                            dismissableMask={true}
                            draggable={false}
                            resizable={false}
                            header="Remove Affiliate"
                            onHide={handleDeleteDialogClose}
                            className="affiliate-dialog affiliate-assign"
                            maskClassName="affiliate-dialog-mask"
                        >
                            <div>
                                <div style={{ marginTop: '1rem' }}>
                                    <p>Are you sure you want to remove this <strong>{userData?.name}</strong> with <strong>{affName || affiliateName}</strong> ?</p>
                                </div>
                                <div style={{ marginTop: '1rem' }}>
                                    <p>Removing the affiliate means that future order credits will no longer be assigned to any affiliate and may also impact the discount value for <strong> {userData?.name} </strong>.</p>
                                </div>
                                <div className="dialog-footer buttons-sections flex gap-3 align-items-center justify-content-end">
                                    <PR.Button label="Confirm" onClick={deleteAffiliate} className="confirm-button min-width" />
                                </div>
                            </div>
                        </PR.Dialog>
                        <PR.Dialog
                            visible={esimActionDialog}
                            dismissableMask={!esimActionLoading}
                            draggable={false}
                            resizable={false}
                            header={isEsimDeleted(activeEsim) ? "Undelete eSIM" : "Delete eSIM"}
                            onHide={() => !esimActionLoading && setEsimActionDialog(false)}
                            className="affiliate-dialog affiliate-assign"
                            maskClassName="affiliate-dialog-mask"
                        >
                            <div>
                                <p>
                                    Are you sure you want to {isEsimDeleted(activeEsim) ? "Undelete" : "delete"} eSIM
                                    <strong> {activeEsim?.iccid}</strong>?
                                </p>
            
                                <div className="buttons-sections flex gap-3 align-items-center justify-content-end">
                                    <PR.Button label="Cancel" 
                                    outlined disabled={esimActionLoading} 
                                    onClick={() => setEsimActionDialog(false)}  
                                    className="confirm-button reset-btn del-esim cancel-btn" />
                                    <PR.Button
                                    label={isEsimDeleted(activeEsim) ? "Undelete" : "Delete"}
                                    severity={isEsimDeleted(activeEsim) ? undefined : "danger"}
                                    loading={esimActionLoading}
                                    onClick={handleEsimAction}
                                    className={`confirm-button del-esim ${isEsimDeleted(activeEsim) ? "restore-btn" : "delete-btn"}`}
                                    />
                                </div>
                            </div>
                        </PR.Dialog>
                        <NameModal setNameModal={setNameModal} nameModal={nameModal} page="details" updateData={setUserData} userId={userIds?.userId} rowData={userIds?.rowData} toast={toast} headers={headers} dispatch={dispatch} />
                        <PR.Menu model={actionMenuItems} popup ref={menuRef} className="custom-menu" />
                        <PR.Toast ref={toast} position='top-right' />
                    </section>
                    <AdminFooter />
                </div>
            </div>
        </>
    );
};

export default CustomerDetails;
